<template>
  <div class="wrap">
    <div class="move">
      <div class="fuwafuwastako"></div>
    </div>
    <div class="striped-background" :style="backgroundStyle">
      <!-- ここに他のコンテンツを配置 -->
      <div class="maintitle">
        <img src="../assets/NJLogo.png" alt="nextjourney" class="imagetitle" />
        <div class="fuwafuwa"></div>
      </div>
    </div>
    <!--以下本体内容-->
    <div ref="bgRef" :class="{ '-animating': isAnimating }" class="bg">
      <span class="title">
        <span><img src="../assets/NJLogo.png" alt="nextjourney" class="subtitle" /></span>
        <span>--AIの魔法を--</span>
        <span><a class="blknj">NEXT JOURNEY</a>
          は<u>生成AIとkintoneを連携</u>させることで、御社のナレッジ化された営業ジャーニーから<u>商談成約率を上げる</u>最適なアシスタントをご提供いたします!
          営業活動を行う中で“<u>次に何をするべきなのか</u>”をサポート!
          <u>営業状況の見える化</u>を実現致します!
          <br>3つのメイン機能「ネクストジャーニー」 「AI アシスト」「リマインド通知」を分かりやすくご紹介致します!</span>
      </span>
    </div>
    <!--機能詳細-->
    <!--ネクストジャーニー-->
    <div>
      <div class="njfunction" ref="njFunctionRef" :class="{ '-animating': isNjAnimating }">
        <div class="photomain"><img src="../assets/ネクストジャーニー挿入用.png"></div>
        <div class="photosub"><img src="../assets/タスクグラフ.png"></div>
        <div class="njtext">
          <div>
            <p class="njtitle">NEXT JOURNEY</p>
            <span class="njtitlesub">ネクストジャーニー</span>
          </div>
          <p>あらかじめ設定した営業ジャーニーに基づいて<br>現在の進捗状況や次のアクションを導き出します！</p>
        </div>
      </div>
      <!--AIアシスト-->
      <div class="njfunction-bl" ref="njFunctionBlRef" :class="{ '-animating': isNjBlAnimating }">
        <div class="photomain-bl"><img src="../assets/AIアシスト機能挿入用_反転.png"></div>
        <div class="photosub-bl"><img src="../assets/AI画面挿入用.png"></div>
        <div class="njtext-bl">
          <div>
            <p class="njtitle">AI ASSIST</p>
            <span class="njtitlesub">AIアシスト</span>
          </div>
          <p>kintoneと生成AIを連携!<br>kintone画面から直接質問を投げかけることができます。<br>返ってきた返答も自動的にkintoneに登場!</p>
        </div>
      </div>
      <!--リマインド機能-->
      <div class="njfunction" ref="njFunctionRemindRef" :class="{ '-animating': isNjRemindAnimating }">
        <div class="photomain"><img src="../assets/リマインダー機能挿入用.png"></div>
        <div class="photosub-remind"><img src="../assets/リマインド設定.png"></div>
        <div class="njtext">
          <div>
            <p class="njtitle">REMIND</p>
            <span class="njtitlesub">リマインド通知</span>
          </div>
          <p>設定した営業ジャーニーの進捗具合を管理！<br>個々のジャーニーにリマインド通知を設定ついうっかり防止します！</p>
        </div>
      </div>
    </div>
    <!--機能詳細-->
    <div class="under">
      <div class="btn-under">
        <a href="">
          <button class="button-20">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
              <path fill="#F6A8B5"
                d="m12.9 5.1 10.7 10.7c.5.5.5 1.4 0 1.9l-1.2 1.2c-.5.5-1.3.5-1.9 0L12 10.4l-8.5 8.5c-.5.5-1.3.5-1.9 0L.4 17.7c-.5-.5-.5-1.4 0-1.9L11.1 5.1c.5-.5 1.3-.5 1.8 0z" />
            </svg>
          </button>
        </a>
        <!-- <a href="" class="btnunder btnunder-border">PUSH！</a> -->
        <a href="/"><button class="btnpink">TOPページに戻る</button></a>
        <a href="/tos"><button class="btnpink">お問い合わせはこちら</button></a>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';

export default {
  name: 'NextJourney',
  data() {
    return {
      stripeCount: 15, // ストライプの数
      color1: '#54ADC3', // 青色のストライプ
      color2: '#FFFFFF' // 白色のストライプ
    }
  },
  computed: {
    backgroundStyle() {
      const stripeWidth = 100 / this.stripeCount;
      let gradient = 'linear-gradient(to right,';
      for (let i = 0; i < this.stripeCount; i++) {
        const color = i % 2 === 0 ? this.color1 : this.color2;
        gradient += `${color} ${i * stripeWidth}%, ${color} ${(i + 1) * stripeWidth}%`;
        if (i < this.stripeCount - 1) gradient += ',';
      }
      gradient += ')';
      return {
        backgroundImage: gradient,
        backgroundSize: '100% 100%'
      };
    }
  },
  setup() {
    const bgRef = ref(null);
    const isAnimating = ref(false);
    const njFunctionRef = ref(null);
    const njFunctionBlRef = ref(null);
    const njFunctionRemindRef = ref(null);
    const isNjAnimating = ref(false);
    const isNjBlAnimating = ref(false);
    const isNjRemindAnimating = ref(false);


    const startAnimation = () => {
      isAnimating.value = false;
      // 強制的にリフローを発生させる
      void bgRef.value.offsetWidth;
      isAnimating.value = true;
    };
    const startNjAnimation = () => {  // 追加
      isNjAnimating.value = false;
      void njFunctionRef.value.offsetWidth;
      isNjAnimating.value = true;
    };
    const startNjBlAnimation = () => {
      isNjBlAnimating.value = false;
      void njFunctionBlRef.value.offsetWidth;
      isNjBlAnimating.value = true;
    };

    const startNjRemindAnimation = () => {
      isNjRemindAnimating.value = false;
      void njFunctionRemindRef.value.offsetWidth;
      isNjRemindAnimating.value = true;
    };

    onMounted(() => {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            startAnimation();
          }
        });
      }, { threshold: 0.1 }); // 10%表示されたらトリガー

      // njfunctionのobserver追加
      const njObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            startNjAnimation();
          }
        });
      }, { threshold: 0.1 });
      const njBlObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            startNjBlAnimation();
          }
        });
      }, { threshold: 0.1 });

      const njRemindObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            startNjRemindAnimation();
          }
        });
      }, { threshold: 0.1 });

      if (bgRef.value) {
        observer.observe(bgRef.value);
      }

      if (njFunctionRef.value) {
        njObserver.observe(njFunctionRef.value);
      }

      if (njFunctionBlRef.value) njBlObserver.observe(njFunctionBlRef.value);
      if (njFunctionRemindRef.value) njRemindObserver.observe(njFunctionRemindRef.value);
    });

    return {
      bgRef,
      isAnimating,
      njFunctionRef,
      njFunctionBlRef,
      njFunctionRemindRef,
      isNjAnimating,
      isNjBlAnimating,
      isNjRemindAnimating
    };
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Rakkas&display=swap');
@import "../css/njfunction.css";
@import "../css/under.css";
@import "../css/topscss.css";
@import "../css/top.css";

.move {
  position: -webkit-sticky;
  position: sticky;
  top: 25%;
  left: 5%;
  z-index: 10;
  width: 20%;
}

/**メイン */
.striped-background {
  width: 100%;
  height: 100vh;
  background-image: v-bind(backgroundStyle);
  background-size: 100% 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.maintitle {
  width: 90%;
  height: 75%;
  background-color: #54ADC3;
  border: 2px solid #54ADC3;
}

.imagetitle {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 70%;
}

@keyframes slideIn {
  from {
    transform: translateY(100%);
  }

  to {
    transform: translateY(0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

/**説明ページ以降のアニメーション

*/
.bg {
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100vh;
  color: #fff;
}

.bg.-visible:before {
  transform: translate(0, 0);
}

.bg:before {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #54ADC3;
  transform: translate(0, 100%);
  transition: transform cubic-bezier(0.215, 0.61, 0.355, 1) .6s;
  content: '';
  transform: translateY(100%);
  transition: none;
}

.bg.-animating:before {
  animation: slideIn 0.6s cubic-bezier(0.215, 0.61, 0.355, 1) forwards;
}

.title span {
  /* 既存のスタイル */
  opacity: 0;
  transform: translateY(40px);
  transition: none;
}

.bg.-animating .title span {
  animation: fadeIn 0.7s linear forwards, slideIn 1s cubic-bezier(0.215, 0.61, 0.355, 1) forwards;
}

.bg.-animating .title span:first-child {
  animation-delay: 0.25s;
}

.bg.-animating .title span:last-child {
  animation-delay: 0.45s;
}

/* テキストのスタイル */
.title {
  display: block;
  color: #ffffff;
  font-family: 'Josefin Sans', sans-serif;
  text-align: center;
  padding: 2%;
}

.subtitle {
  width: 30%;
}

/**アンダーバー */
u {
  background: linear-gradient(transparent 60%, #C59F42 50%);
  text-decoration: none;
}

.blknj {
  color: #000;
  font-size: larger;
  font-weight: 700;
  font-family: 'Rakkas', cursive;
}

.title span {
  display: block;
  opacity: 0;
  transition: transform cubic-bezier(0.215, 0.61, 0.355, 1) 1s, opacity linear 0.7s;
}

.title span:first-child {
  transform: translate(0, 40px);
  font-size: 20px;
  transition-delay: 0.25s;
}

.title span:last-child {
  margin-top: 18px;
  transform: translate(0, 30px);
  font-size: 29px;
  transition-delay: 0.45s;
}

.bg.-visible .title span {
  opacity: 1;
  transform: translate(0, 0);
}

.bg.-displayed .title span {
  transition: none;
}

/****** Base style. ******/
body {
  margin: 0;
}

/**揺れるキャラクターのアニメーション */
.fuwafuwa {
  animation: fuwafuwa 3s ease-in-out infinite alternate;
  background: url(../assets/TUKI.png) no-repeat center center / 140px auto;
  display: inline-block;
  transition: 1.5s ease-in-out;
  width: 150px;
  height: 150px;
  margin-top: 25%;
  margin-left: 80%;
}

@keyframes fuwafuwa {
  0% {
    transform: translate(0, 0) rotate(-7deg);
  }

  50% {
    transform: translate(0, -7px) rotate(0deg);
  }

  100% {
    transform: translate(0, 0) rotate(7deg);
  }
}

.fuwafuwastako {
  position: absolute;
  top: 20%;
  /* 上からの位置を調整 */
  left: 6%;
  /* 左からの位置を調整 */
  z-index: 10;
  /* 重なり順を制御 */
  animation: fuwafuwastako 3s ease-in-out infinite alternate;
  background: url(../assets/スタ子_スティック.png) no-repeat center center / 140px auto;
  /* inline-blockからblockに変更 */
  transition: 1.5s ease-in-out;
  width: 150px;
  height: 150px;
}

@keyframes fuwafuwastako {
  0% {
    transform: translate(0, 0) rotate(-7deg);
  }

  50% {
    transform: translate(0, -7px) rotate(0deg);
  }

  100% {
    transform: translate(0, 0) rotate(7deg);
  }
}

@media screen and (max-width: 480px) {
  .fuwafuwa {
    animation: fuwafuwa 3s ease-in-out infinite alternate;
    background: url(../assets/TUKI.png) no-repeat center center / 100px auto;
    display: inline-block;
    transition: 1.5s ease-in-out;
    width: 110px;
    height: 110px;
    margin-top: 100%;
    margin-left: 65%;
  }

  .fuwafuwastako {
    position: absolute;
    top: 20%;
    /* 上からの位置を調整 */
    left: 6%;
    /* 左からの位置を調整 */
    z-index: 10;
    /* 重なり順を制御 */
    animation: fuwafuwastako 3s ease-in-out infinite alternate;
    background: url(../assets/スタ子_スティック.png) no-repeat center center / 80px auto;
    /* inline-blockからblockに変更 */
    transition: 1.5s ease-in-out;
    width: 90px;
    height: 90px;
  }

  .imagetitle {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 90%;
  }

  .maintitle {
    width: 90%;
    height: 85%;
    background-color: #54ADC3;
    border: 2px solid #54ADC3;
  }

  .title span:last-child {
    margin-top: 18px;
    transform: translate(0, 30px);
    font-size: 15px;
    transition-delay: 0.45s;
  }

  .subtitle {
    width: 80%;
  }
}

/**詳細情報用 */
.njfunction {
  opacity: 0;
  transform: translateY(40px);
  transition: none;
}

.njfunction.-animating {
  animation: fadeIn 0.7s linear forwards,
    slideIn 1s cubic-bezier(0.215, 0.61, 0.355, 1) forwards;
}
</style>